import React, { useState } from "react";
import {
  getCategories,
  getServicesTypes,
  getStates,
  getUser,
} from "../../../api";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import ReactSelect from "react-select";
import { MultiSelect } from "../../../components/multiSelect";
import { dropdownStyles } from "../../buy/buy";
import Client from "../../../utils/client";
import { toast } from "react-toastify";
import { api_url } from "../../../constant";

function UpdateProfileInfo() {
  const [information, setInformation] = useState({});
  const [state, setState] = useState(null);
  const [subCategory, setSubCategory] = useState([]);
  const [service, setService] = useState([]);
  const { data } = useQuery({
    queryKey: ["user"],
    queryFn: () => getUser(),
    onSuccess: (data) => {
      reset({
        name: data.name,
        dob: new Date(data.dob).toISOString().split("T")[0],
        location: {
          label: data._state.name,
          value: data._state.id,
        },
        // service_id: {
        //   label: data.service.name,
        //   value: data.service.id,
        // },
        gender: data.gender,
        cooperativeType: data?.cooperativeType,
        NoOfMembers: data?.NoOfMembers,
        // type: {
        //   label:
        //     data.type === "supplier"
        //       ? "مقدم خدمات"
        //       : data.type === "farmer"
        //       ? "مزارع"
        //       : "تاجر",
        //   value: data.type,
        // },
      });
    },
  });
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    reset,
    watch,
    formState: { isSubmitted, isDirty, isValid },
  } = useForm({ mode: "onChange" });

  const { data: states } = useQuery({
    queryKey: ["states"],
    queryFn: () => getStates(),
    initialData: [],
  });
  const { data: subCategories } = useQuery({
    queryKey: ["categories"],
    queryFn: () => getCategories(),
    initialData: [],
  });

  const { data: services } = useQuery({
    queryKey: ["services"],
    queryFn: () => getServicesTypes(),
    initialData: [],
  });

  const onSubmit = async (data) => {
    const _data = {
      name: data.name,
      location: data.location.value,
      gender: data.gender,
      dob: new Date(data.dob),
      NoOfMembers: data.NoOfMembers ? data.NoOfMembers : null,
      cooperativeType: data.cooperativeType ? data.cooperativeType : null,
    };
    const res = await Client.patch(api_url + "/users/profile", _data, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then(() => {
        toast("تم التحديث بنجاح", { type: "success" });
      })
      .catch((err) => {
        toast("حدث خطأ الرجاء المحاولة مجدداً", { type: "error" });
      });
  };
  return (
    <div className="my-10 px-5 lg:px-7 " dir="rtl">
      <h1 className="lg:text-start font-bold  text-xl lg:text-[24px] my-14 lg:my-10">
        تحديث معلومات الحساب
      </h1>

      <form
        dir="rtl"
        className="flex flex-col gap-3 lg:w-[60%] lg:mr-24"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="flex lg:flex-row flex-col justify-between gap-3 lg:gap-6">
          <div className="flex flex-col gap-3 lg:w-1/2">
            <label htmlFor="newPhonenumber" className="font-bold text-sm">
              الإسم
            </label>
            <input
              type="text"
              name="name"
              className="rounded-lg focus:ring-0 border-[#c8c8c8] focus:border-primary placeholder:text-sm "
              placeholder=""
              {...register("name", {
                required: true,
              })}
            />
          </div>
          {data?.type !== "cooperative" && (
            <div className="flex flex-col gap-3 lg:w-1/2">
              <label htmlFor="password" className="font-bold text-sm">
                النوع
              </label>
              <div className="w-full">
                <ReactSelect
                  options={[
                    {
                      label: "ذكر",
                      value: "male",
                    },
                    {
                      label: "أنثى",
                      value: "female",
                    },
                  ]}
                  value={{
                    label: getValues().gender === "male" ? "ذكر" : "أنثى",
                    value: getValues().gender,
                  }}
                  onChange={(value) =>
                    setValue("gender", value.value, { shouldDirty: true })
                  }
                  hideSelectedOptions={false}
                  closeMenuOnSelect={true}
                  isRtl
                  placeholder="النوع"
                  className=""
                />
              </div>
            </div>
          )}
          {data?.type === "cooperative" && (
            <div className="flex flex-col gap-3 lg:w-1/2">
              <label htmlFor="cooperativeType" className="font-bold text-sm">
                نوع التعاونية
              </label>
              <div className="w-full">
                <ReactSelect
                  options={[
                    { label: "مستهلك", value: "consumer" },
                    { label: "زراعة", value: "agriculture" },
                  ]}
                  value={{
                    label:
                      getValues().cooperativeType === "consumer"
                        ? "مستهلك"
                        : "زراعة",
                    value: getValues().cooperativeType,
                  }}
                  onChange={(value) =>
                    setValue("cooperativeType", value.value, {
                      shouldDirty: true,
                    })
                  }
                  hideSelectedOptions={false}
                  closeMenuOnSelect={true}
                  isRtl
                  placeholder="نوع التعاونية"
                  className=""
                />
              </div>
            </div>
          )}
        </div>

        <div className="flex lg:flex-row flex-col justify-between gap-3 lg:gap-6">
          {data?.type !== "cooperative" && (
            <div className="flex flex-col gap-3 lg:w-1/2">
              <label htmlFor="newPhonenumber" className="font-bold text-sm">
                تاريخ الميلاد
              </label>
              <input
                type="date"
                name="dob"
                className="rounded-lg focus:ring-0 border-[#c8c8c8] focus:border-primary placeholder:text-sm text-end placeholder:text-end placeholder:m-0"
                placeholder=""
                {...register("dob", {
                  required: true,
                })}
              />
            </div>
          )}
          {data?.type === "cooperative" && (
            <div className="flex flex-col gap-3 lg:w-1/2">
              <label htmlFor="NoOfMembers" className="font-bold text-sm">
                عدد الأعضاء
              </label>
              <input
                type="number"
                name="NoOfMembers"
                className="rounded-lg focus:ring-0 border-[#c8c8c8] focus:border-primary placeholder:text-sm text-end placeholder:text-end placeholder:m-0"
                placeholder=""
                {...register("NoOfMembers", {
                  required: true,
                })}
              />
            </div>
          )}
          <div className="flex flex-col gap-3 lg:w-1/2">
            <label htmlFor="password" className="font-bold text-sm">
              الولاية
            </label>
            <div className="w-full">
              <ReactSelect
                options={states.map((e) => {
                  return { label: e.name, value: e.id };
                })}
                value={{
                  label: getValues().location?.label,
                  value: getValues().location?.value,
                }}
                onChange={(value) => {
                  setValue(
                    "location",
                    {
                      label: value.label,
                      value: value.value,
                    },
                    { shouldDirty: true }
                  );
                  //   citiesRefetch();
                }}
                hideSelectedOptions={false}
                closeMenuOnSelect={true}
                isRtl
                placeholder={<span className="font-bold">الولاية</span>}
              />
            </div>
          </div>
        </div>
        {/* <div className="flex gap-6">
          <div className="flex flex-col gap-3 w-1/2">
            <label htmlFor="password" className="font-bold text-sm">
              نوع العميل
            </label>
            <div className="w-full">
              <ReactSelect
                options={[
                  { label: "مزارع", value: "farmer" },
                  { label: "تاجر", value: "buyer" },
                  { label: "مقدم خدمات", value: "supplier" },
                ]}
                value={getValues().type}
                //   styles={dropdownStyles}
                onChange={(e) =>
                  setInformation({ ...information, type: e.value })
                }
                hideSelectedOptions={false}
                closeMenuOnSelect={true}
                isRtl
                placeholder={"نوع العميل"}
              />
            </div>
          </div>
          {information.type ? (
            information.type === "supplier" ? (
              <div className="flex flex-col gap-3 w-1/2">
                <label htmlFor="password" className="font-bold text-sm">
                  الولاية
                </label>
              
                <div className="w-full">
                  <MultiSelect
                    options={services.map((e) => {
                      return { label: e.name, value: e.id };
                    })}
                    value={service}
                    onChange={setService}
                    //   styles={dropdownStyles}
                    placeHolder={
                      <span className="after:content-['*'] after:mr-0.5 after:text-red-500">
                        الخدمة
                      </span>
                    }
                  />
                </div>
              </div>
            ) : (
              <div className="flex flex-col gap-3 w-1/2">
                <label htmlFor="password" className="font-bold text-sm">
                  الولاية
                </label>
                <div className="w-full">
                  <MultiSelect
                    options={subCategories.map((e) => {
                      return { label: e.name, value: e.id };
                    })}
                    value={subCategory}
                    onChange={setSubCategory}
                   
                    placeHolder={"المحصول"}
                  />
                </div>
              </div>
            )
          ) : (
            ""
          )}
        </div> */}
        <button
          type="submit"
          disabled={!isDirty || isSubmitted}
          className="w-[50%] mx-auto text-white bg-primary py-2 mt-3 rounded-lg disabled:opacity-50 transition"
        >
          تأكيد
        </button>
      </form>
    </div>
  );
}

export default UpdateProfileInfo;
